// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_c3ecxz4{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;background-color:var(--background);max-width:520px;min-width:520px;width:100%;max-height:450px;min-height:450px;height:100%;border-radius:8px;position:relative;}\n", ""]);
// Exports
module.exports = exports;
